var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { ref: "container", staticClass: "vks-association-region-plot" },
    [
      _vm.showLegend
        ? _c("div", { staticClass: "vks-association-region-plot-legend" }, [
            _vm._m(0),
            _vm._m(1),
            _vm._m(2),
            _vm._m(3),
            _vm._m(4),
            _vm._m(5),
            _vm._m(6),
            _vm._m(7),
          ])
        : _vm._e(),
      _c(
        "div",
        { staticClass: "vks-association-region-plot-canvas-wrap" },
        [
          _c("canvas", {
            ref: "canvas",
            staticClass: "vks-association-region-plot-canvas",
            class: {
              "is-pannable": _vm.canPan,
              "is-x-axis-hover": _vm.xAxisBandHover,
              "is-dot-hover": _vm.dotHover,
            },
            on: {
              mousedown: _vm.onMouseDown,
              mousemove: _vm.onMouseMove,
              mouseout: _vm.onMouseOut,
              mouseup: _vm.onMouseUp,
              click: _vm.onCanvasClick,
            },
          }),
          _c("VariantSifterZoomCenterMarker", {
            attrs: {
              "region-view-area": _vm.regionViewArea,
              "region-zoom": _vm.regionZoom,
              "plot-margin": _vm.plotMargin,
            },
            on: {
              "update:regionViewArea": function ($event) {
                return _vm.$emit("update:regionViewArea", $event)
              },
            },
          }),
        ],
        1
      ),
      _c("VariantSifterVariantDotMenu", {
        attrs: {
          open: _vm.dotMenuOpen,
          "variant-id": _vm.dotMenuVariantId,
          "is-starred": _vm.dotMenuIsStarred,
          "anchor-x": _vm.dotMenuX,
          "anchor-y": _vm.dotMenuY,
        },
        on: {
          "set-reference": _vm.onDotMenuSetReference,
          "toggle-star": _vm.onDotMenuToggleStar,
        },
      }),
      _c("div", {
        ref: "tooltip",
        staticClass: "vks-association-region-plot-tooltip hidden",
      }),
      _vm.loading
        ? _c("p", { staticClass: "vks-association-region-plot-status" }, [
            _vm._v(" Loading plot overlays… "),
          ])
        : _vm._e(),
      _vm.error
        ? _c(
            "p",
            {
              staticClass: "vks-association-region-plot-error",
              attrs: { role: "alert" },
            },
            [_vm._v(" " + _vm._s(_vm.error) + " ")]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "vks-legend-item" }, [
      _c("span", {
        staticClass: "plot-legend-diamond",
        attrs: { "aria-hidden": "true" },
      }),
      _c("span", [_vm._v("Reference variant")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "vks-legend-item" }, [
      _c("span", {
        staticClass: "plot-legend-dot",
        staticStyle: { "background-color": "#82409950" },
      }),
      _c("span", [_vm._v("r2 == 1")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "vks-legend-item" }, [
      _c("span", {
        staticClass: "plot-legend-dot",
        staticStyle: { "background-color": "#d0363350" },
      }),
      _c("span", [_vm._v("1 > r2 >= 0.8")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "vks-legend-item" }, [
      _c("span", {
        staticClass: "plot-legend-dot",
        staticStyle: { "background-color": "#ee982d50" },
      }),
      _c("span", [_vm._v("0.8 > r2 >= 0.6")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "vks-legend-item" }, [
      _c("span", {
        staticClass: "plot-legend-dot",
        staticStyle: { "background-color": "#4db05250" },
      }),
      _c("span", [_vm._v("0.6 > r2 >= 0.4")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "vks-legend-item" }, [
      _c("span", {
        staticClass: "plot-legend-dot",
        staticStyle: { "background-color": "#32afd550" },
      }),
      _c("span", [_vm._v("0.4 > r2 >= 0.2")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "vks-legend-item" }, [
      _c("span", {
        staticClass: "plot-legend-dot",
        staticStyle: { "background-color": "#2074b650" },
      }),
      _c("span", [_vm._v("0.2 > r2 > 0")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "vks-legend-item" }, [
      _c("span", {
        staticClass: "plot-legend-dot",
        staticStyle: { "background-color": "#33333320" },
      }),
      _c("span", [_vm._v("No data")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }